import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as RightArrowIcon } from 'src/assets/icons/bonus-game/right-arrow.svg';
import { MobileHeader } from '../../components/Header';
import { PageWrapper } from '../../ui/common';
import { useEffect, useState } from 'react';
import { bonusGameApi } from 'src/api/bonus-game';
import { GetBonusTreeSeasonsResponseObject } from 'src/api/Api';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  position: relative;
`;

const Title = styled.h1`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 0;
  position: absolute;
  left: 0;
  right: 0;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1;
`;

const PlaceholderDiv = styled.div`
  width: 24px;
  height: 24px;
`;

const SeasonItem = styled.div`
  background-color: #1a222c;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

const SeasonInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SeasonTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SeasonNumber = styled.span`
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
`;

const SeasonStatus = styled.span`
  color: #bfff38;
  font-size: 12px;
  font-weight: 500;
`;

const SeasonDate = styled.div`
  color: #525a67;
  font-size: 14px;
`;

function formatDate(dateString: any) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export const SeasonsList = () => {
  const navigate = useNavigate();
  const [seasons, setSeasons] = useState<GetBonusTreeSeasonsResponseObject[]>(
    [],
  );

  useEffect(() => {
    (async () => {
      const seasonsRes = await bonusGameApi.getSeasons();
      setSeasons(seasonsRes.result);
    })();
  }, []);

  const handleSelectSeason = (seasonId: number, seasonPeriod: string) => {
    navigate(`/bonus-game/season/${seasonId}`, {
      state: {
        seasonPeriod: seasonPeriod,
      },
    });
  };

  return (
    <PageWrapper>
      <MobileHeader title="Past Seasons" />

      {seasons.map(season => (
        <SeasonItem
          key={season.id}
          onClick={() =>
            handleSelectSeason(
              season.id,
              `${formatDate(season.startDate)} - ${formatDate(season.endDate)}`,
            )
          }>
          <SeasonInfo>
            <SeasonTitle>
              <SeasonNumber>{season.seasonName}</SeasonNumber>
              {season.isFinished && <SeasonStatus>Finished</SeasonStatus>}
            </SeasonTitle>
            <SeasonDate>
              {season.id === 2
                ? '15 April 2025 - 15 May 2025'
                : `${formatDate(season.startDate)}
              - ${formatDate(season.endDate)}`}
            </SeasonDate>
          </SeasonInfo>
          <RightArrowIcon color="rgba(82, 90, 103, 1)" />
        </SeasonItem>
      ))}
    </PageWrapper>
  );
};
